import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { transformDataColumns } from '../../../utils/transformDataColumns';
import { getYearFromTimestamp } from '../../../utils/timestamp';
import './styles.css';

const messages = defineMessages({
  title: {
    id: 'hubs.top-areas-of-study.title',
    defaultMessage: 'Top Areas of Study',
  },
  footer: {
    id: 'hubs.top-areas-of-study.footer',
    defaultMessage: 'Latest available data from ',
  },
});

function TopAreasOfStudy({
  intl,
  topAreasOfStudy,
  lastUpdatedMajor,
  topAreasOfStudyTitle,
}) {
  const areasOfStudy = {};
  Object.values(topAreasOfStudy).forEach((area) => {
    areasOfStudy[`${area.value}`] = { value: true };
  });
  const [leftSide, rightSide] = transformDataColumns(
    areasOfStudy,
    areasOfStudy,
    null,
    false,
  );
  return (
    <div className="top-areas-container common-full-width" data-cy="top-areas-container">
      <div className="common-core-width">
        {topAreasOfStudyTitle && (
          <h1 className="top-areas-title">{topAreasOfStudyTitle}</h1>
        )}
        <h2 className="heading" tabIndex={0}>
          {intl.formatMessage(messages.title)}
        </h2>
        <div className="top-areas-core">
          <div className="row">
            <ul className="column">
              {leftSide.map((value, key) => (
                <li key={key}>{value}</li>
              ))}
            </ul>
            <ul className="column">
              {rightSide.map((value, key) => (
                <li key={key}>{value}</li>
              ))}
            </ul>
          </div>
          <div className="top-areas-footer" tabIndex={0}>
            {`${intl.formatMessage(messages.footer)}${getYearFromTimestamp(
              lastUpdatedMajor,
            )}`}
          </div>
        </div>
      </div>
    </div>
  );
}

TopAreasOfStudy.propTypes = {
  topAreasOfStudy: PropTypes.object,
  lastUpdatedMajor: PropTypes.number,
  topAreasOfStudyTitle: PropTypes.any,
  intl: PropTypes.object,
};

export default injectIntl(TopAreasOfStudy);
